<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import SidebarNavigation from "@/components/partials/SidebarNavigation.vue";
import TopNavbar from "@/components/partials/TopNavbar.vue";
import CommandPalette from "@/components/CommandPalette.vue";

defineProps({
  fullWidth: { type: Boolean, default: false },
});

const route = useRoute();
const pageTitle = ref("");

const updatePageTitle = () => {
  pageTitle.value = route.meta.title || "Default Title";
};

updatePageTitle();
</script>

<template>
  <div class="dashboard-layout">
    <TopNavbar :title="pageTitle" />
    <div class="body-wrapper">
      <SidebarNavigation />
      <div class="content-wrapper">
        <div class="page-content" :class="{ 'page-content--full': fullWidth }">
          <slot />
        </div>
      </div>
    </div>
    <CommandPalette />
  </div>
</template>

<style lang="scss" scoped>
.dashboard-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.body-wrapper {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--content-bg);
}

.page-content {
  flex: 1;
  overflow-y: auto;
  padding: var(--spacing-6);

  &--full {
    padding: 0;
  }

  @media (max-width: 1024px) {
    padding: var(--spacing-4);
    &--full { padding: 0; }
  }

  @media (max-width: 768px) {
    padding: var(--spacing-3);
    &--full { padding: 0; }
  }
}

@media (max-width: 1024px) {
  /* On tablet/mobile the sidebar is position:fixed so the
     body-wrapper doesn't need to account for its width */
  .body-wrapper {
    overflow: visible;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }
}
</style>
